import { render, staticRenderFns } from "./PersonalConsiderations.vue?vue&type=template&id=148e0f83"
import script from "./PersonalConsiderations.vue?vue&type=script&lang=ts"
export * from "./PersonalConsiderations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148e0f83')) {
      api.createRecord('148e0f83', component.options)
    } else {
      api.reload('148e0f83', component.options)
    }
    module.hot.accept("./PersonalConsiderations.vue?vue&type=template&id=148e0f83", function () {
      api.rerender('148e0f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/PersonalConsiderations.vue"
export default component.exports